import Vue from 'vue';
import VModal from '~/node_modules/vue-js-modal';

Vue.use(VModal, { dynamic: true });
